import { render } from "./NewEvent.vue?vue&type=template&id=3914af3c&scoped=true"
import script from "./NewEvent.vue?vue&type=script&lang=js"
export * from "./NewEvent.vue?vue&type=script&lang=js"

import "./NewEvent.vue?vue&type=style&index=0&id=3914af3c&lang=scss&scoped=true"

import exportComponent from "/Users/vonwong/Dropbox/ClaudeCode/MeetingOS/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3914af3c"]])

export default __exports__